module.exports = "/lucky-balls/img/drum/drum_loop_017.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/drum/drum_loop_017.png
// module id = 1032
// module chunks = 0